import { call, fork, put, take } from 'redux-saga/effects';
import {Action} from 'redux-actions';
import {enqueueErrorSnackbar, enqueueSuccessSnackbar} from '../action/snackbarCommands';
import {getI18n} from 'react-i18next';
import Logger from '../common/logger';
import {
    StartRentalPayload, fetchBookingDetails, startRental,
} from '../action/bookingsCommands';
import {Api} from '../api';

const onStartRental = function*(orderId: string, items: string[]) {
    try {
        yield call(Api.startRental, orderId, items);

        yield put(enqueueSuccessSnackbar({
            message: getI18n().t('snackbar.success.start_rental'),
        }));

        yield put(fetchBookingDetails({ bookingId: orderId }));
    } catch (e) {
        Logger('Saga').error(e);
        yield put(enqueueErrorSnackbar({
            message: getI18n().t('snackbar.error.start_rental'),
        }));
    }
};

export function* startRentalFlow() {
    while (true) {
        const action: Action<StartRentalPayload> = yield take(startRental.toString());
        yield fork(onStartRental, action.payload.orderId, action.payload.items);
    }
}
